import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { AccueilComponent } from './accueil.component';
import { BlankComponent } from './blank.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', component: BlankComponent },
  { path: 'accueil', component: AccueilComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: '' }
];
